

const SectionHead = ({title, description, className}) => {
  return (
    <div className={`section__head ${className}`}>
    <h2>{title}</h2>
    <med>{description}</med>
    </div>
  )
}

export default SectionHead